import { acceptHMRUpdate, defineStore } from "pinia";

// Fora do state de proposito: sao handles de timer, nao dado de tela. Em state
// virariam reativos e disparariam render a cada navegacao sem nenhum ganho.
let veuTimerSeguranca = null
let veuTimerSaida = null
let veuAbertoEm = 0

// Tempo minimo do veu na tela, por pedido: a transicao dura 2,5s mesmo quando a
// rota de destino monta instantaneamente. Se a montagem demorar MAIS que isso o
// veu fica ate ela terminar - este e um piso, nao uma duracao fixa.
const VEU_MIN_MS = 2500

// "FLOW.SIGHT", "Flow.Sight" e "flowsight" sao o mesmo produto.
const norm = (v) => String(v || '').toLowerCase().replace(/[^a-z0-9]/g, '')

// As preferencias do usuario ficam no userInfo do localStorage, gravadas pelo
// authStore no login. Sao lidas ja aqui, na criacao do state, porque o guard do
// router consulta disabledBasePaths antes de qualquer componente montar: quem
// hidratasse so no created() do App entregaria um F5 dentro de um produto sem
// direito.
function settingsSalvas () {
  try {
    return (JSON.parse(localStorage.getItem('userInfo')) || {}).settings || null
  } catch (e) {
    return null
  }
}

// Marca o que o userdb nao listou. Mexe SO no `locked`: `disabled` continua
// querendo dizer "produto que ainda nao existe" (AutoQuote, Market.Desk), e e
// por isso que o userdb nunca reabilita um desses - ele nao escreve nesse
// campo. Lista vazia (ou backend fora do ar) nao tranca nada: seria trocar
// "nao consegui perguntar" por uma /home toda cadeada.
function aplicarProdutosHabilitados (cards, settings) {
  const habilitados = Array.isArray(settings && settings.enabledProducts)
    ? settings.enabledProducts.map(norm).filter(Boolean)
    : []

  cards.forEach((card) => {
    card.locked = habilitados.length ? !habilitados.includes(norm(card.value)) : false
  })
  return cards
}

// As classes de instrumento que o userdb liberou (fx, commodities,
// fixedincome). Mesma regra dos produtos: lista vazia nao tranca nada.
function classesHabilitadas (settings) {
  const lista = settings && settings.instrumentClasses
  return Array.isArray(lista) ? lista.map(norm).filter(Boolean) : []
}

// Duracao do fade-in do veu. TEM que bater com a transicao .veil-fade-* do
// RouteTransitionOverlay - o router espera este tempo antes de trocar a rota.
export const VEU_FADE_MS = 220

// Pausa DEPOIS que o veu ja esta totalmente na tela e antes de comecar a montar
// o destino. Por pedido: o veu entra primeiro, respira, e so entao a pagina de
// destino comeca a carregar. Cabe dentro do piso de VEU_MIN_MS, entao nao alonga
// a transicao - so muda em que ponto dela a troca acontece.
export const VEU_ESPERA_MS = 500

// Se a navegacao morrer no meio (guard que aborta, chunk que falha ao baixar),
// o afterEach nunca roda e o veu ficaria na tela para sempre, sem saida.
// Tem que ficar folgadamente acima de VEU_MIN_MS, senao o teto de emergencia
// dispararia antes do piso e cortaria transicoes normais.
const VEU_MAX_MS = 12000

// Fora do state so para nao afogar o bloco de estado. Os dois campos que
// parecem o mesmo: `disabled` e produto que nao existe no front (nao clica, diz
// "em breve", e o guard do router barra a rota); `locked` e produto que existe e
// o usuario nao tem (clica, abre borrado, mas nao pode virar o app padrao).
// Hoje NENHUM card usa `disabled` - o AutoQuote e o Market.Desk eram os dois e
// foram ligados; o campo fica para o proximo produto anunciado antes de existir.
// `locked` PRECISA nascer no literal - o Vue 2 nao observa propriedade
// adicionada depois, e o applyUserSettings escreve nele com a store ja reativa.
function cardsBase () {
  const cards = [
    // A ordem aqui E o layout da /home: o grid la usa md="6", entao os cards
    // caem em duas colunas linha a linha. Cada par abaixo e uma linha da tela -
    // coluna esquerda, coluna direita. Reordenar aqui reordena a /home.
    { id:1, icon: 'mdi-cash-multiple',        name: 'AutoQuote', descKey: 'productCards.descriptions.autoQuote', link: '/autoquote', value:'AutoQuote', tags:['pricing', 'execution'], disabled: false, locked: false },
    { id: 4, icon: "mdi-calculator-variant",  name: 'Nexus', descKey: 'productCards.descriptions.nexus', link: '/nexus', value: 'NEXUS', tags: ['pricing', 'valuation'], disabled: false, locked: false },
    { id: 2, icon: "mdi-chart-line",          name: 'Flow.Sight', descKey: 'productCards.descriptions.flowSight', link: '/flowsight', value: 'FLOW.SIGHT', tags: ['analytics', 'trading'], disabled: false, locked: false },
    { id: 9, icon: "mdi-shield-half-full",    name: 'hedgeOS', descKey: 'productCards.descriptions.hedgeOS', link: '/hedgeos', value: 'HEDGEOS', tags: ['hedging', 'hedge'], disabled: false, locked: false },
    { id: 3, icon: "mdi-sync",                name: 'AutoHedge', descKey: 'productCards.descriptions.autoHedge', link: '/autohedge', value: 'Auto.Hedge', tags: ['market', 'maker', 'trading'], disabled: false, locked: false },
    { id: 7, icon: "mdi-finance",             name: 'Port.AR', descKey: 'productCards.descriptions.portAr', link: '/portar/positions', value: 'PORT.AR', tags: ['portfolio', 'risk'], disabled: false, locked: false },
    { id: 5, icon: "mdi-lightning-bolt-outline", name: 'Plexus', descKey: 'productCards.descriptions.plexus', link: '/plexus', value: 'PLEXUS', tags: ['execution', 'ems', 'liquidity'], disabled: false, locked: false },
    { id: 8, icon: "mdi-laptop",              name: 'Market.Desk', descKey: 'productCards.descriptions.launchpad', link: '/marketdesk/fx-markets', value: 'Market.Desk', tags: ['marketdesk', 'launchpad'], disabled: false, locked: false },
   // { id:6, icon:"mdi-book-open",  name:'BOOK.SIGHT', desc:'Book Management & Analytics', link:'/book', value:'BOOK.SIGHT', tags:['management']}, 
  ]

  return cards
}

export const useCoreStore = defineStore("core", {
  state: () => ({
    selectedProduct: JSON.parse(localStorage.getItem('selectedProduct')) || { name: '', path: '', value:'', assetClass:[]},
    selectedUrl : '/',
    settingsModal: false,
    pauseDealOrderFlow:false,
    requestDemo : false,
    // Veu de transicao entre aplicacoes. `navigatingApp` e { name, icon } do
    // destino, resolvido por appForPath - null enquanto nada esta navegando.
    navigating: false,
    navigatingApp: null,
    // Os tres rotulos de tela. Quais deles ESTE usuario tem e outra coisa:
    // `userInstrumentClasses`, lido do userdb.
    assetClasses:[ 'FX', 'COMMODITIES', 'FIXED INCOME' ],
    userInstrumentClasses: classesHabilitadas(settingsSalvas()),
    contentCard: aplicarProdutosHabilitados(cardsBase(), settingsSalvas()),
    tabs: [
        {label: 'FX', link:'/marketdesk/fx-markets', value:'fx',icon:"mdi-laptop", tags:['marketdesk']},
        {label: 'Commodities', link:'/marketdesk/commodities-markets', value: 'commodities',icon:"mdi-laptop", tags:['marketdesk']},
        {label: 'Fixed Income', link:'/marketdesk/fixed-income-markets', value:'fixedincome',icon:"mdi-laptop", tags:['marketdesk']},
    ]
  }),
  getters: {
    getSelectedProduct: (state) => state.selectedProduct,
    getSettingsModal: (state) => state.settingsModal,
    getPauseDealOrderFlow:(state) => state.pauseDealOrderFlow,
    getSelectedUrl(state) {
      const path = state.selectedProduct.path
      if (!path) return '/'
      // O produto favorito vive no localStorage e pode ter sido DESABILITADO
      // depois de salvo - foi o caso do Market.Desk. Devolver esse path faz o
      // login empurrar o usuario para uma rota que o proprio guard vai barrar,
      // gerando um redirect inutil. Melhor ja responder /home.
      // Alem do produto desabilitado, o TRANCADO: um favorito salvo antes de o
      // acesso mudar levaria o login direto para a previa borrada.
      const base = '/' + path.split('/')[1]
      const barrado = this.disabledBasePaths.includes(base) || this.lockedBasePaths.includes(base)
      return barrado ? '/home' : path
    },
    enabledCards: (state) => state.contentCard.filter(c => !c.disabled),
    enabledTabs(state) {
      const disabledBases = new Set(
        state.contentCard.filter(c => c.disabled).map(c => '/' + c.link.split('/')[1])
      )
      return state.tabs.filter(t => !disabledBases.has('/' + t.link.split('/')[1]))
    },
    disabledBasePaths: (state) =>
      state.contentCard.filter(c => c.disabled).map(c => '/' + c.link.split('/')[1]),
    // O `name` da view ("Flow.Sight", "hedgeOS") e o `value` do card sao o
    // mesmo produto escrito de dois jeitos - dai o norm. View que nao casa com
    // nenhum card (a Book) nao tem entitlement a consultar: fica liberada, e
    // nao trancada por omissao.
    isProductLocked: (state) => (viewName) => {
      const card = state.contentCard.find(c => norm(c.value) === norm(viewName))
      return !!card && !!card.locked
    },
    // Espelha o isProductLocked, para classe de instrumento: 'FX' casa com
    // 'fx' e 'FIXED INCOME' com 'fixedincome' pela mesma normalizacao.
    isInstrumentClassLocked: (state) => (className) => {
      if (!state.userInstrumentClasses.length) return false
      return !state.userInstrumentClasses.includes(norm(className))
    },
    lockedBasePaths: (state) =>
      state.contentCard.filter(c => c.locked && c.link).map(c => '/' + c.link.split('/')[1]),
  },
  actions: {
    // Chamado pelo beforeEach do router quando a navegacao troca de aplicacao.
    startNavigation (app) {
      clearTimeout(veuTimerSeguranca)
      clearTimeout(veuTimerSaida)
      veuAbertoEm = Date.now()
      this.navigatingApp = app
      this.navigating = true
      veuTimerSeguranca = setTimeout(() => { this.navigating = false }, VEU_MAX_MS)
    },

    // Chamado pelo afterEach, depois que a pagina de destino ja pintou.
    finishNavigation () {
      if (!this.navigating) return
      clearTimeout(veuTimerSeguranca)
      clearTimeout(veuTimerSaida)
      const restante = Math.max(0, VEU_MIN_MS - (Date.now() - veuAbertoEm))
      veuTimerSaida = setTimeout(() => { this.navigating = false }, restante)
    },

    getApplicationName (title){
      const chosenTitle = this.contentCard.find(c=> c.name === title)
      if (!chosenTitle) return { title, descKey: '' }
      return {
        title: chosenTitle.name,
        descKey: chosenTitle.descKey
      }
    },
    // Preferencias do usuario vindas do backend. O `defaultProduct` daqui e a
    // ORIGEM do app padrao - o que o usuario escolher depois nos cards
    // sobrescreve o selectedProduct local ate o proximo login.
    applyUserSettings(settings) {
      if (!settings) return

      aplicarProdutosHabilitados(this.contentCard, settings)
      this.userInstrumentClasses = classesHabilitadas(settings)

      const wanted = norm(settings.defaultProduct)
      if (!wanted) return

      const card = this.contentCard.find(c => norm(c.value) === wanted && !c.disabled && !c.locked)
      if (card) {
        this.saveSelectedProduct({ name: card.name, path: card.link, value: card.value })
      }
    },
    saveSelectedProduct(selected) {
      //save in local storage AND here
      localStorage.setItem("selectedProduct", JSON.stringify(selected));
      this.selectedProduct.name = selected.name;
      this.selectedProduct.path = selected.path || ""
      this.selectedProduct.value = selected.value || ''
    },
    removeSelectedProduct()
    {
      this.selectedProduct = { name: '', path: '', value:''}
      localStorage.removeItem('selectedProduct')
    },
    setRequestDemo(val)
    {
      this.requestDemo = val
    },
    // Fonte unica do gate de blur por view: produto trancado (fora do
    // enabledProducts do userdb) abre borrado, com o prompt de demo. E o que
    // torna o card sem acesso clicavel na /home sem entregar a tela: o guard do
    // router deixa passar - so barra produto DESABILITADO -, e o blur e o que
    // separa quem tem acesso de quem esta vendo a previa.
    // Devolve true quando a view DEVE ser borrada.
    // As telas do Market.Desk passam tambem a classe de instrumento: as tres
    // dividem o mesmo `name` ('Market.Desk'), entao sem esse segundo argumento
    // elas so poderiam borrar juntas.
    evaluateBlur(viewName, instrumentClass) {
      const trancado =
        this.isProductLocked(viewName) ||
        (!!instrumentClass && this.isInstrumentClassLocked(instrumentClass))
      this.setRequestDemo(trancado)
      return trancado
    },
    handleSettingsModal(value) {
      if (typeof value !== "boolean") return;
      this.settingsModal = value;
    },
    savePauseDealOrderFlow(val)
    {
      if (typeof val !== 'boolean')return;
      this.pauseDealOrderFlow = val
     }
  },
});

// Sem isto, editar uma action com o `serve` no ar troca o modulo mas NAO troca
// a store ja instanciada: a tela continua rodando a versao antiga ate um reload
// inteiro, e o sintoma e uma correcao que "nao pegou".
if (module.hot) {
  module.hot.accept(acceptHMRUpdate(useCoreStore, module.hot));
}
